






















































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  setInteractionMode,
  ValidationObserver,
  ValidationProvider,
  extend,
} from 'vee-validate';

import { required } from 'vee-validate/dist/rules';

import FilePicker from '@shared/components/FilePicker/index.vue';
import { SupportModel } from '@shared/models/Support';
import { SupportService } from '@parents/services';
import { parseErrors } from '@shared/helpers/common.helper';
import { ServerErrorsModel } from '@shared/models/Common/ServerErrorsModel';
// import { FileContentModel } from '@shared/models/Common';

extend('required', {
  ...required,
  message: '{_field_} can not be empty',
});

setInteractionMode('eager');

const service = new SupportService();

@Component({
  components: {
    ValidationObserver,
    ValidationProvider,
    FilePicker,
  },
})
export default class FaqForm extends Vue {
  loading = false;

  public serverErrors: string[] = [];

  @Prop({ default: false })
  private readonly public!: boolean;

  @Prop({ default: () => service.sendPrivateSupportMessage.bind(service) })
  private readonly method!: any;

  actionItem: SupportModel = {
    subject: '',
    body: '',
    email: '',
    name: '',
    // contentBase64: '',
    // isContentChanged: false,
    // content: { file: '' } as FileContentModel,
  } as SupportModel;

  onContentChange(content: string) {
    if (this.actionItem.content) {
      this.actionItem.content.file = content;
      this.actionItem.contentBase64 = content;
      this.actionItem.isContentChanged = true;
    }
  }

  clearForm(): void {
    this.actionItem.subject = '';
    this.actionItem.body = '';
    this.actionItem.email = '';
    this.actionItem.name = '';
    (this.$refs.observer as any).reset();
  }

  async submit() {
    const observer = (this.$refs.observer as any);
    const isValid = await observer.validate();
    if (!isValid) return;
    this.loading = true;
    try {
      (this.$refs.observer as any).reset();
      const data: { [key: string]: any } = {
        subject: this.actionItem.subject,
        body: this.actionItem.body,
      };
      if (this.public) {
        data.email = this.actionItem.email;
        data.name = this.actionItem.name;
      }
      await this.method(data);
      this.loading = false;
      this.clearForm();
    } catch (error) {
      const { Name, Email, Subject, Body, ...rest } = error.response.data.errors;
      observer.setErrors({
        Name, Email, Subject, Body
      });
      this.serverErrors = parseErrors(
        rest as ServerErrorsModel
      );
    } finally {
      this.loading = false;
    }
  }
}
